import { render } from "./index.vue?vue&type=template&id=16383d9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=16383d9e&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16383d9e"]])

export default __exports__